import BezierEditor from "./BezierEditor";
import uncontrollable from "uncontrollable";

export default uncontrollable(BezierEditor, {
  value: "onChange"
});
